module.exports = __webpack_public_path__ + "static/media/Highgate Close N6 (10).a2f91c18.JPG";